import { Stepper } from '@material-ui/core'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import styled from 'styled-components'

import { rspTheme } from '../../styles/rspTheme'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      padding: '0',
      backgroundColor: 'transparent',
      margin: '24px 0 80px',
      color: 'var(--theme-color)',
      position: 'relative',
      '& .MuiStep-root': {
        padding: '0',
        margin: '0',
        textAlign: 'left',
        transition: 'flex 0.2s ease-in-out',
        '&.activeGroup': {
          flexGrow: 1,
        },
        '&.inactiveGroup': {
          flexGrow: 0,
          '& .MuiStepLabel-labelContainer': {
            display: 'none',
          },
        },
        '&.terminusContainer': {
          margin: '0 0 0 auto',
          paddingRight: '0',
          justifySelf: 'flex-end',
          '& button': {
            justifyContent: 'flex-end',
            width: '6px',
          },
        },
      },
      '&::before': {
        content: "''",
        display: 'block',
        position: 'absolute',
        borderTop: '1px solid var(--theme-color)',
        top: '19px',
        left: '22px',
        right: '0',
        height: '1px',
        transition: 'left 0.3s ease-in-out',
      },
      '&.firstActive::before': {
        left: '28px',
      },
      '& .MuiStepIcon-text': {
        display: 'none',
      },
      '& .MuiStepLabel-root': {
        position: 'relative',
        '& .MuiStepLabel-labelContainer': {
          position: 'absolute',
          textAlign: 'left',
          minWidth: '16ch',
          left: '16px',
          top: '24px',
          '& .MuiStepLabel-label': {
            color: 'var(--theme-color)',
            lineHeight: '1',
            '& .MuiTypography-root': {
              transition: 'all 0.2s ease-in-out',
              '&.visible': {
                opacity: 1,
              },
              '&.hidden': {
                opacity: 0,
              },
            },
          },
        },
      },
      '& .MuiButtonBase-root': {
        padding: '0',
        width: '40px',
        height: '40px',
        '&:hover, &:focus-visible': {
          '& .MuiStepIcon-root': {
            color: rspTheme.palette.primary.light,
          },
        },
        '&.MuiStepButton-root': {
          margin: '0',
        },
      },
      '& .MuiStepIcon-root': {
        color: 'rgba(218, 121, 137, 1)',
        opacity: '0.7',
        width: '16px',
        height: '16px',
        transform: 'scale(1)',
        transformOrigin: 'center',
        transition: 'all 0.3s ease-in-out',
        '&.MuiStepIcon-active': {
          transform: 'scale(1.5)',
        },
      },
      '& .MuiStepConnector-root': {
        display: 'none',
      },
    },
    terminus: {
      pointerEvents: 'none',
      '& .MuiStepIcon-root': {
        color: 'var(--theme-color)',
        opacity: '1',
        width: '6px',
        height: '6px',
        marginTop: '-1px',
      },
      '& .MuiStepLabel-iconContainer': {
        paddingRight: '0',
      },
    },
    mobileRoot: {
      width: '100%',
      marginBottom: '40px',
      backgroundColor: 'transparent',
      justifyContent: 'center',
      zIndex: 10,
      '& .MuiMobileStepper-dots': {
        display: 'none',
      },
    },
  }),
)

export const RoundButton = styled.button`
  width: 40px;
  height: 40px;
  background-color: transparent;
  border: 1px solid ${rspTheme.palette.primary.main};
  border-radius: 50%;
  color: ${rspTheme.palette.primary.main};
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  flex-shrink: 0;

  &.dark {
    color: #ffffff;
    border-color: #ffffff;
  }

  &:hover:not(:disabled),
  &:focus:not(:disabled) {
    color: ${rspTheme.palette.primary.background};
    background-color: ${rspTheme.palette.primary.main};
  }

  &:disabled {
    opacity: 0.6;
    cursor: unset;
  }

  @media (max-width: ${rspTheme.breakpoints.values.smmd}px) {
    margin: 0 24px;
    &.prevSlideButton {
      position: absolute;
      left: 20px;
      top: -80px;
    }
    &.nextSlideButton {
      position: absolute;
      right: 20px;
      top: -80px;
    }
  }
`

export const StyledStepper = styled(Stepper)`
  &.technology {
    margin: 0 auto 30px;
    flex-grow: unset;
    &::before {
      border-top: none;
    }
  }
`

export const NextPrevWrapper = styled.div`
  width: 100%;
  button {
    position: absolute;
    color: white;
    border-color: white;
    left: -300px;
    top: -80px;
    &.nextSlideButton {
      right: -300px;
      left: unset;
    }
  }
`
